import { sharePackages } from '@/util/cloudFunctions/sharePackages'
import { ref } from 'vue'

export function useEditSharedPackage() {
    const isLoading = ref(false)

    async function editUserPackage(req: {
        sharedPackage: StudioMembership
        currentPackage: StudioMembership
        creditShared: number
    }) {
        isLoading.value = true

        const currentUser = req.currentPackage.userId
        const sharedToUser = req.sharedPackage.userId

        const payload = makeSharePackagesPayload({
            currentPackage: req.currentPackage,
            sharedPackage: req.sharedPackage,
            creditShared: req.creditShared,
            currentUser: currentUser,
            sharedToUser: sharedToUser,
        })

        const result = await sharePackages(
            payload.packageId,
            payload.numClassesShared,
            payload.userSharedTo,
            payload.userSharing
        )
        if (!result.success) {
            isLoading.value = false
            throw new Error(result.error)
        }
        isLoading.value = false
    }

    return {
        isLoading,
        editUserPackage,
    }
}

export type StudioMembership = {
    id: string
    classesLeft: number
    numClasses: number
    userId: string
}

type SharePackagesPayload = {
    packageId: string
    numClassesShared: number
    userSharedTo: string
    userSharing: string
}

function makeSharePackagesPayload(req: {
    currentPackage: StudioMembership
    sharedPackage: StudioMembership
    creditShared: number
    currentUser: string
    sharedToUser: string
}) {
    const {
        currentPackage,
        creditShared,
        currentUser,
        sharedToUser,
        sharedPackage,
    } = req

    if (creditShared > sharedPackage.numClasses) {
        throw new Error('Credit shared is greater than the number of classes')
    }

    const payload: SharePackagesPayload = {
        packageId: currentPackage.id,
        numClassesShared: 0,
        userSharedTo: '',
        userSharing: '',
    }

    const diff = creditShared - sharedPackage.classesLeft
    const isSharedBack = diff < 0

    payload.numClassesShared = Math.abs(diff)
    if (isSharedBack) {
        payload.packageId = sharedPackage.id
        payload.userSharedTo = currentUser
        payload.userSharing = sharedToUser
    } else {
        payload.userSharedTo = sharedToUser
        payload.userSharing = currentUser
    }

    return payload
}
